// extracted by mini-css-extract-plugin
export var lg = "_e5-7";
export var md = "_e5-6";
export var placeholderContainer = "_e5-1";
export var placeholderIcon = "_e5-2";
export var productImage = "_e5-0";
export var sm = "_e5-5";
export var xl = "_e5-8";
export var xs = "_e5-4";
export var xxs = "_e5-3";